module.exports = {
        srcSet: __webpack_public_path__ + "static/media/man-in-suit-664.bf27e4a1.webp"+" 664w",
        images: [{path: __webpack_public_path__ + "static/media/man-in-suit-664.bf27e4a1.webp",width: 664,height: 664}],
        src: __webpack_public_path__ + "static/media/man-in-suit-664.bf27e4a1.webp",
        toString: function(){return __webpack_public_path__ + "static/media/man-in-suit-664.bf27e4a1.webp"},
        
        width: 664,
        height: 664
      }